export enum InterventionMotive {
    DIAGNOSTIC = "DIAGNOSTIC",
    HOME_INTERVENTION = "HOME_INTERVENTION",
    COMMISSIONING = "COMMISSIONING",
    STA = "STA"
}
